import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})

export class MapaProvider {

  app: any;
  google_api_key: any;

  contentHeader: Headers = new Headers({'Content-Type': 'application/json'});

  constructor(public http: HttpClient) {
    this.google_api_key = 'AIzaSyC3DZ1qXAb-Gz18pFGrofWGzo_SzR8RYYQ';
  }

  getAddress(params: { lat: string; long: string; }) {
    let url = 'http://maps.googleapis.com/maps/api/geocode/json?latlng=' + params.lat + ',' + params.long;
    return this.http.get<any>(url).pipe(map(res => <any>res));
  }

  getStreetAddress(params: { lat: string; long: string; }) {
    let url = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + this.google_api_key + '&latlng=' + params.lat + ',' + params.long + '&result_type=street_address';
    return this.http.get<any>(url).pipe(map(res => <any>res));

  }

  // GET(url: string) {
  //   return this.http.get(url).pipe(map(res => res));
  // }

  // POST(url: any, params: any) {
  //   // let options = new RequestOptions({
  //   //   headers: this.contentHeader
  //   // });
  //   // return this.http.post(url, params, options).pipe(map(res => res.json());
  // }

  // DEL(url: any) {
  //   // let options = new RequestOptions({
  //   //   headers: this.contentHeader
  //   // });
  //   // return this.http.delete(url, options).pipe(map(res => res.json());
  // }

}
